/**
 * FeatureCard Component
 *
 * Feature: 011-registration-welcome
 *
 * Displays a single feature card with icon, title, and description.
 * Used on welcome page to showcase key BOSI features.
 */

import React from 'react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <div className="card bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200">
      {/* Icon */}
      <div className="flex items-center justify-center w-14 h-14 mb-4 bg-primary-100 rounded-full">
        {icon}
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-gray-800 mb-2" style={{ fontFamily: 'Nunito, sans-serif' }}>
        {title}
      </h3>

      {/* Description */}
      <p className="text-gray-600 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
